/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { FormatFunction, ParseFunction, useFormContext } from '@jalik/react-form'
import React from 'react'
import { CheckboxProps, RadioProps, TextInput, TextInputProps } from '@mantine/core'

export type FormFieldProps<C extends React.ElementType> = {
  formatter?: FormatFunction;
  name?: string;
  parser?: ParseFunction;
  render?: C;
  value?: string;
} & React.ComponentPropsWithoutRef<C>

export type CustomFormFieldProps<C> = FormFieldProps<React.ComponentType<C>>

export type FormCheckboxFieldProps = CustomFormFieldProps<CheckboxProps>
export type FormRadioFieldProps = CustomFormFieldProps<RadioProps>
export type FormTextFieldProps = CustomFormFieldProps<TextInputProps>

function FormField<C extends React.ElementType> (props: FormFieldProps<C>) {
  const {
    name,
    formatter,
    parser,
    render: Component = TextInput,
    ...others
  } = props

  const {
    getError,
    getFieldProps
  } = useFormContext()

  const attrs = getFieldProps(name, { ...others }, {
    format: formatter,
    parse: parser
  })
  const error = getError(name)

  if (error instanceof Error) {
    attrs.error = error.message
  }
  return <Component {...attrs} />
}

export default FormField
